// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jeaVjG_0uT_Vr1EnjFDM{background:var(--yellow-40);color:var(--content-primary-tertiary)}.gNiKjsPkkVPwLGXg6cLg{color:var(--content-primary-primary)}`, "",{"version":3,"sources":["webpack://./src/widgets/ContactEnrollment/ui/EnrollmentContactsTable/helpers/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,2BAAA,CACA,qCAAA,CAEA,sBACE,oCAAA","sourcesContent":[".highlighter {\n  background: var(--yellow-40);\n  color: var(--content-primary-tertiary);\n\n  &--label {\n    color: var(--content-primary-primary);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"highlighter": `jeaVjG_0uT_Vr1EnjFDM`,
	"highlighter--label": `gNiKjsPkkVPwLGXg6cLg`
};
export default ___CSS_LOADER_EXPORT___;
